import React, { Component } from "react";
import Button from "../../../../components/Button";
import Dropzone from "react-dropzone";
import { log } from "../../../../../redux/modules/logger/actions";
import { BatchUploadManager } from "@traceair/bsp-sdk";
import config from "../../../../../config";
import { EVENT_FROM_BACKOFFICE_STORAGE_PROXY } from "../../../../../redux/modules/logger/constants";
import { connect } from "react-redux";
import { pushMetric } from "../../../../../redux/modules/metrics/actions";
import { AppDispatch } from "../../../../../store";
import { getSiteLevelToken } from "../../../../../redux/accessTokenManagerActions";
import { escapeFile } from "../fileModule";

type Props = {
  value?: string;
  label?: string;
  customerId: string;
  siteId: string;
  uploadPath: string;
  onInputSuccess: (value: string[]) => void;
  dispatch: AppDispatch;
};

type State = {
  uploadedFilesNumber: number;
  totalFilesNumber: number;
  uploadedFiles: string[];
  error?: string;
};
const defaultState: State = {
  uploadedFilesNumber: 0,
  totalFilesNumber: 0,
  uploadedFiles: [],
  error: "",
};
class ActionUploadFileset extends Component<Props, State> {
  state: State = defaultState;
  uploadManager: BatchUploadManager;

  constructor(props: Props) {
    super(props);
    this.state = defaultState;
  }

  componentDidMount() {
    this.initUploadManager();
  }

  initUploadManager() {
    const {
      partSizeBytes,
      requestTimeoutMs,
      retryIntervalMs,
      maxParallelRequests,
      maxParallelFiles,
    } = config.multipleFileUpload;

    const { customerId, siteId, uploadPath } = this.props;
    this.uploadManager = new BatchUploadManager({
      bspHost: config.endpoints.backofficeStorage,
      customerId,
      siteId,
      uploadPath,
      partSizeBytes,
      requestTimeoutMs,
      retryIntervalMs,
      maxParallelRequests,
      maxParallelFiles,
      logFunction: (message: string) => {
        this.props.dispatch(
          log(EVENT_FROM_BACKOFFICE_STORAGE_PROXY, "1", message),
        );
      },
      metricFunction: (metricName, metricValue) => {
        this.props.dispatch(pushMetric(metricName, metricValue));
      },
      getJwtToken: async () => {
        return this.props.dispatch(getSiteLevelToken(customerId, siteId));
      },
      onFileUploaded: (
        uploadedFilesNumber: number,
        totalFilesNumber: number,
      ) => {
        this.handleFileUploadSuccess(uploadedFilesNumber, totalFilesNumber);
      },
      onUploadCompleted: ({ filePaths }) => {
        this.setState(
          {
            uploadedFiles: filePaths,
          },
          () => {
            this.onUploadComplete();
          },
        );
      },
    });
  }

  handleDrop = (inputFiles: File[]) => {
    const files = inputFiles.map((file) => escapeFile(file));
    this.setState(
      (state) => {
        return {
          totalFilesNumber: state.totalFilesNumber + files.length,
        };
      },
      () => {
        this.uploadManager.startUpload(files);
      },
    );
  };

  handleFileUploadSuccess = (
    uploadedFilesNumber: number,
    totalFilesNumber: number,
  ) => {
    this.setState({
      uploadedFilesNumber,
      totalFilesNumber,
    });
  };

  onUploadComplete() {
    window.onbeforeunload = null;
    const { s3Endpoint, s3ExchangeBucket } = config.hackForCreatingS3LinkForBws;
    const filePathsInS3 = this.state.uploadedFiles.map(
      (filePath) => `https://${s3Endpoint}/${s3ExchangeBucket}/${filePath}`,
    );
    this.props.onInputSuccess && this.props.onInputSuccess(filePathsInS3);
  }

  render() {
    const { value, label } = this.props;

    const filename =
      (value &&
        `Uploaded ${value.length} ${value.length === 1 ? "file" : "files"}`) ||
      label ||
      "upload file";

    if (
      this.state &&
      this.state.totalFilesNumber &&
      this.state.totalFilesNumber !== this.state.uploadedFilesNumber
    ) {
      return <div>Uploading..</div>;
    }

    return (
      <Dropzone onDrop={this.handleDrop} multiple={true}>
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <Button type="primary" label={filename} onClick={() => null} />
          </div>
        )}
      </Dropzone>
    );
  }
}

export default connect()(ActionUploadFileset); // connect to pass dispatch function
